const TONES = {
  draft: 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200',
  pending_approval: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  submitted: 'bg-cyan-100 dark:bg-cyan-900 text-cyan-800 dark:text-cyan-100',
  info_requested: 'bg-amber-100 dark:bg-amber-900 text-amber-900 dark:text-amber-100',
  approved: 'bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-100',
  rejected: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200',
  recalled: 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-100',
  waiting: 'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400',
  pending: 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100',
  skipped: 'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400',
  // A `notify`-kind workflow step settles here: a one-way email went out, nobody
  // decided anything, so it gets its own tone rather than reading as an approval.
  sent: 'bg-teal-100 dark:bg-teal-900 text-teal-800 dark:text-teal-100',
};

export default function StatusBadge({ status }) {
  return (
    <span
      className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${
        TONES[status] || 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200'
      }`}
    >
      {String(status || 'unknown').replace(/_/g, ' ')}
    </span>
  );
}
